import React from 'react'

import {
  Box,
  CSSKeywords,
  DisplayPosition,
  ResponsiveValue,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import patternNarrowSVG from '../../../assets/EffortlessHomeCookingSection/egg-pattern-narrow.svg'
import patternWideSVG from '../../../assets/EffortlessHomeCookingSection/egg-pattern-wide.svg'
import { CSSObject } from '@emotion/react'

const responsiveBackground: ResponsiveValue<string> = [
  `right/475px no-repeat url(${patternNarrowSVG})`,
  `center/contain no-repeat url(${patternNarrowSVG})`,
  null,
  `center/contain no-repeat url(${patternWideSVG})`,
]

const responsiveBgPosition: ResponsiveValue<string> = [
  null,
  '20px',
  null,
  'calc(50% - 330px)',
  'calc(50% - 250px)',
]

const OverlayBg = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(responsiveBackground, ['background']) as CSSObject),
}))

const Overlay = withCitrusTheme(OverlayBg, (theme) => ({
  left: '-30px',
  [`@media (min-width: 375px)`]: { right: '-55px', left: CSSKeywords.Unset },
  ...(theme.responsiveStyle(responsiveBgPosition, ['right']) as CSSObject),
}))

export function PatternOverlay() {
  return (
    <Overlay
      position={DisplayPosition.Absolute}
      height="445px"
      minWidth={['466px']}
      bottom={['335px', null, null, CSSKeywords.Unset]}
      width={['466px', null, null, '900px']}
    />
  )
}
